import { GELATO_ADMIN_CLIENT_UID } from '../../../lib/constants';
import { ClientRelationType } from '../client-relation-type.enum';

export const getClientRelationTypeByClientId = (clientId: string) => {
  if (!clientId) {
    return null;
  }

  if (clientId === GELATO_ADMIN_CLIENT_UID) {
    return ClientRelationType.INTERNAL;
  }

  return ClientRelationType.EXTERNAL;
};
